import axios from 'axios';

$(document).ready(function(){
    //animações
    AOS.init();

    //open menu mobile
    $("#nav-mobi").on("click", function(e) {
        e.preventDefault();
        $(this).toggleClass("opened");

          $(".nav-wraper").toggleClass("opened");
          $("body #app").toggleClass("hidden-over");

          return false;
    });

    //open sub-menu 3ro nivel
    $(".dropdown-open").on("click", function(e) {
        e.preventDefault();
        $(this).next('.dropdown-links').toggleClass("opened");

        return false;
    });

    //toTop
    $("#toTop").on("click", function(e) {
        e.preventDefault();
        //$(window).scrollTop(0);

        var body = $("html, body");
        body.stop().animate({scrollTop:0}, 500, 'swing', function() {
          // alert("Finished animating");
        });

        return false;
    });

    //loop banner
    if($("#hero-banner #zoom-mouse").is(":visible")){
        var myTimer;
        var setBanner = $("#hero-banner #zoom-mouse");
        var bubleItem = $('.icon-hero.active');

        function loopBanner() {
            myTimer = setTimeout(fadeProduct, 6000);}

        function fadeProduct() {
            bubleItem = $('.icon-hero.active');
            $('.icon-hero.active').animate({
                opacity: 0
              }, 250, function() {
                var itemIn = bubleItem.next('.icon-hero').length > 0 ? bubleItem.next('.icon-hero') : $('.icon-hero').first();
                itemIn.addClass('active');
                bubleItem.removeClass('active');
                itemIn.animate({
                    opacity: 1
                  }, 500);
              });
            clearTimeout(myTimer);
            loopBanner();
        }
        loopBanner(); //loop banner start
    }

    //mouse movement
    $(function(){
    // boxRollovers("#zoom-mouse");
    });

    function boxRollovers($elem)
    {
        //Ref: https://codepen.io/onge/pen/NPGaGP

        var selector = $($elem);
        var oLayer = null;
        var XAngle = 0;
        var YAngle = 0;
        var Ewidth = 0;
        var Z = 0;

        selector.on("mousemove",function(e){
            var $this = $(this);
            var XRel = e.pageX - $this.offset().left;
            var YRel = e.pageY - $this.offset().top;
            var width = $this.width();
            Ewidth = width;

            YAngle = (0.5 - (XRel / width)) * 20;
            XAngle = -(0.5 - (YRel / width)) * 20;
            updateView($this.children(".icon-hero"), Ewidth, YAngle, Z);
        });

        selector.on("mouseleave",function(){
            oLayer = $(this).children(".icon-hero");
            oLayer.css({"transform":"perspective("+Ewidth+"px) translateZ(0) rotateX(0deg) rotateY(0deg)","transition":"all 150ms linear 0s","-webkit-transition":"all 150ms linear 0s"});
        });
    }

    function updateView(oLayer, Ewidth, YAngle, Z)
    {
        oLayer.css({"transform":"perspective(" + Ewidth + "px) translateZ(" + Z + "px) rotateY(" + YAngle + "deg)","transition":"none","-webkit-transition":"none"});
    }

    // Fecha modal de download
    $("#accept-form .button-close").on('click', function(){
        $("#accept-form").removeClass('active');

         // Reset error handler
         $("#accept-form").find('.form_wrap').addClass('active');
         $("#accept-form").find('.error_wrap').removeClass('active');
         $("#accept-form").find(".alert_wrap").html("<p></p>");

        return false;
    });

    // Abre modal
    $(".input-down-file").on('click', function() {
        var type = $(this).attr('data-type');
        var file = $(this).attr('data-file');

        // preenche os dados do download no modal
        $("#accept-form").find('.input-accept--file').val(file);
        $("#accept-form").find('.input-accept--type').val(type);

        // position modal
        var callPosition = $(".prod_call2action").offset().top;
        $("#accept-form").css('top',callPosition);

        // pos+altura
        var heightForm = $("#accept-form").height();
        var somaAltura = heightForm + callPosition;

        if(somaAltura > $("#root").height()){
            $("#accept-form").css('top','auto');
            $("#accept-form").css('bottom','60px');
        }

        // abre o modal
        $("#accept-form").addClass('active');
        return false;
    });

    // Form accept download 3d
    var maskDoc = function (val) {
            return val.replace(/\D/g, '').length < 12 ? '000.000.000-009' : '00.0000.0000/0000-00';
        },
        options = {onKeyPress: function(val, e, field, options) {
            field.mask(maskDoc.apply({}, arguments), options);
        }
    };

    // Run mask
    $(".input-accept--doc").mask(maskDoc, options);

    // Send request download
    $("#accept-request-download").on('click', function (e) {
        e.preventDefault();

        // Não aceite dos termos
        var check = $("#accept-form").find('.input-accept--check').is(':checked');
        if(!check) {
            //console.log(check);
            $("#accept-form").find(".alert_wrap").html("<p>Você precisa aceitar os termos de compromisso.</p>");
            return false;
        }

        // inputs form
        var inputs = {
            name: $("#accept-form").find('.input-accept--name').val(),
            email: $("#accept-form").find('.input-accept--email').val(),
            document: $("#accept-form").find('.input-accept--doc').val(),
            file: $("#accept-form").find('.input-accept--file').val(),
        };

        // is complete?
        var complete = true;
        Object.keys(inputs).forEach(function(key) {
            if( inputs[key] === '' || inputs[key] === undefined ) {
                complete = false;
            }
        });

        // alert error empty
        if(!complete) {
            $("#accept-form").find(".alert_wrap").html("<p>Você precisa preencher todos os campos.</p>");
            return false;
        }

        // send post
        axios.post('/api/download', inputs)
        .then( response => {
            //status true
            if(response.data.status) {
                //make download
                downloadFile(response.data.message);
                
            } else {
                //status false
                throw "Error: Status false from API";
            }
        })
        .catch(error => {
            console.error(error);
            
            // show error message
            $("#accept-form").find('.form_wrap').removeClass('active');
            $("#accept-form").find('.error_wrap').addClass('active');
        })

        // Empty form
        $("#accept-form").find('.form_wrap')[0].reset();
        $("#accept-form").removeClass('active');

        return false;
    });
    

    // Download Funcion
    window.downloadFile = function (sUrl) {

        //iOS devices do not support downloading. We have to inform user about this.
        if (/(iP)/g.test(navigator.userAgent)) {
            alert('Your device does not support files downloading. Please try again in desktop browser.');
            return false;
        }
    
        //If in Chrome or Safari - download via virtual link click
        if (window.downloadFile.isChrome || window.downloadFile.isSafari) {
            //Creating new link node.
            var link = document.createElement('a');
            link.href = sUrl;
    
            if (link.download !== undefined) {
                //Set HTML5 download attribute. This will prevent file from opening if supported.
                var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
                link.download = fileName;
            }
    
            //Dispatching click event.
            if (document.createEvent) {
                var e = document.createEvent('MouseEvents');
                e.initEvent('click', true, true);
                link.dispatchEvent(e);
                return true;
            }
        }
    
        // Force file download (whether supported by server).
        if (sUrl.indexOf('?') === -1) {
            sUrl += '?download';
        }
    
        window.open(sUrl, '_self');
        return true;
    }
    
    window.downloadFile.isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    window.downloadFile.isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;


    //select boxes
    // enableSelectBoxes();
    /*
    function enableSelectBoxes(){
        $('div.selectBox').each(function(){
            var elem = $(this);
            elem.children('span.selected').html(elem.children('div.selectOptions').children('span.selectOption:first').html());
            elem.attr('value',elem.children('div.selectOptions').children('span.selectOption:first').attr('value'));


            elem.children('span.selected,span.selectArrow').click(function(){
                var child = $(this);
                $('div.selectOptions').each(function(){
                    $(this).css('display','none');
                });

                if(child.parent().children('div.selectOptions').css('display') == 'none'){
                    child.parent().children('div.selectOptions').css('display','block');
                }
                else
                {
                    child.parent().children('div.selectOptions').css('display','none');
                }
            });

            elem.find('span.selectOption').click(function(){
                $(this).parent().css('display','none');
                $(this).closest('div.selectBox').attr('value',$(this).attr('value'));
                $(this).parent().siblings('span.selected').html($(this).html());
            });


            //$('div.selectBox').mouseleave(function() {
                  //if ($('div.selectOptions').is(':visible')) {
                    //$('div.selectOptions').css('display','none');
                //}
            //});

        });

    } 
    */
});


// WEBPACK FOOTER //
// ./resources/assets/js/app/jquery.js